module.exports = __webpack_public_path__ + "img/clipboard-grey-icon.ad0f1bf3.svg";